<template>
  <!-- 顶部通栏组件 -->
  <!-- <app-topnav /> -->
  <!-- 头部组件 -->
  <div class="app_layout">
    <AppHeader />
    <div class="content">
      <!-- <keep-alive> -->
      <router-view />
      <!-- </keep-alive> -->
    </div>
    <!-- 底部footer -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/Header'
import AppFooter from './components/Footer'
export default {
  name: 'AppLayout',
  components: {
    AppHeader,
    AppFooter,
  }
}
</script>

<style scoped lang="less">
.content {
  min-height: calc(100vh - 250px);
  margin: 0 auto;
  // width: 1240px;
}
</style>
